export default __webpack_public_path__ + "static/media/bg-2.072a762f.png";